export * from "./privacy-policy1";
